import axios from "../axios";
const END_POINT = "/referral-ways";

const getReferralWays = () => axios.get(`${END_POINT}`);
const searchReferralWays = (payload) => axios.post(`${END_POINT}/search`,payload);

export {
  getReferralWays,
  searchReferralWays
};
